import { MutationParams } from '@/interfaces/mutationParams';
import axios from "@/lib/axios";
import { useMutation, useQuery } from "@tanstack/vue-query";
import { OpenPayCard } from "@/interfaces/openPayCard";
import { useToast } from "vue-toastification";
import useCustomMutation from './useCustomMutation';

interface Params {
  card_id: number | string;
}
interface Props {
  params: Params;
  immediate?: boolean
}

const getCard = async (params: Params) => {
  const { data } = await axios.get<OpenPayCard>(`/api/cards/${params!.card_id}`);
  return data;
};

const deleteCard = async (params: Params) => {
  const { data } = await axios.delete(`/api/cards/${params!.card_id}`);
  return data;
};



const useOpenpayCard = (props?: Props) => {

  const { params, immediate = true } = props || {};

  const toast = useToast();

  const { data, isLoading, refetch, isFetching } = useQuery(["card", params?.card_id], () => getCard({ ...params! }), {
    enabled: params ? immediate : false,
    retry: false,
  });


  const deleteMutation = useMutation(
    (MutationParams: MutationParams<Params>) =>
      deleteCard(MutationParams.params),
    useCustomMutation(toast, "delete")
  );


  return {
    data,
    isLoading,
    refetch,
    isFetching,


    deleteCardMutation: deleteMutation,
    deleteCard: deleteMutation.mutate,
    deleteCardAsync: deleteMutation.mutateAsync,
    deleteCardLoading: deleteMutation.isLoading
  };
};

export default useOpenpayCard;
